const state = {
    user: {
        id: null,
        permissions: [],
        roles: [],
        outlets: [],
    },
};

const getters = {
    user(state) {
        return state.user;
    },

    userPermissions(state) {
        return state.user.permissions;
    },

    userRoles(state) {
        return state.user.roles;
    },

    userOutlets(state) {
        return state.user.outlets;
    },

    hasSuperAdminRole(state, getters) {
        return getters.userRoles.indexOf('inventory_admin') >= 0;
    },

    hasPermissionTo: (state, getters) => permission => {
        return !!getters.userPermissions.find(p => p === permission);
    },
};

const mutations = {
    setUser(state, user) {
        state.user = user;
    },
};

const actions = {
    setUser({ commit }, user) {
        throwIfInvalidParameters(user);
        commit('setUser', user);
    },
};

var throwIfInvalidParameters = function(user) {
    if (typeof user !== 'object') {
        throw new TypeError('Invalid argument for user parameter');
    }

    if (!(user.permissions instanceof Array)) {
        throw new TypeError('Invalid argument for user permissions');
    }

    if (!(user.roles instanceof Array)) {
        throw new TypeError('Invalid argument for user roles');
    }

    if (!(user.outlets instanceof Array)) {
        throw new TypeError('Invalid argument for user outlets');
    }
};

export default {
    namespaced: true,
    state: state,
    getters: getters,
    mutations: mutations,
    actions: actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/auth/lib/state/index.js